<template>
  <page
    :custom-style="{
      backgroundColor: '#fff',
      minHeight: '100vh'
    }"
  >
    <!-- 初始白底加载遮罩 -->
    <div v-if="initialLoading" class="page-initial-loading">
      <van-loading type="spinner" color="#17C261" size="28px" />
    </div>
    <maple-nav-bar
      v-if="!isMiniProgram"
      class="cms-nav-bar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      :opacity-style="!isEmpty"
      :opacity="opacity"
      :title="''"
      :left-arrow-color="isEmpty ? '#444' : '#fff'"
      :background="background"
      :title-color="titleColor"
      @click-left="goBack"
    >
      <template #left>
        <div :class="['nav-left', { 'with-bg': titleColor === 'transparent' }]">
          <maple-icon
            class="maple-nav-bar__arrow"
            color="#fff"
            name="left_outlined"
            @click.stop="goBack"
          />
          <div
            :class="['nav-area', 'with-bg']"
            @click.stop="showAreaPicker = true"
          >
            <img :src="locationIcon" alt="loc" class="nav-loc-icon" />
            <span class="text" :style="{ color: isEmpty ? '#444' : '#fff' }"
              >我的家乡：{{ areaDisplayTextShort }}</span
            >
          </div>
        </div>
      </template>
    </maple-nav-bar>

    <!-- 小程序环境：将地区选择单独展示在顶部，而不是导航栏内 -->
    <div
      v-if="isMiniProgram"
      class="mini-area"
      @click.stop="showAreaPicker = true"
    >
      <img :src="locationIcon" alt="loc" class="nav-loc-icon" />
      <span class="text">我的家乡：{{ areaDisplayTextShort }}</span>
    </div>

    <div
      ref="expandHeader"
      :class="['hot-sale-header', { mini: isMiniProgram }]"
      :style="{
        backgroundImage: 'url(' + headImg + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }"
    >
      <div class="header-inner" @click="showSupplementInfo">
        <p class="header-title">{{ pageTitle }}</p>
        <div v-if="contributeText" class="contribute-box">
          <span class="contribute-text" v-html="contributeText"></span>
        </div>
      </div>
    </div>
    <div class="rank-cotent">
      <div v-if="!isEmpty">
        <div
          :class="{
            'expand-tab': true,
            fixed: pageFixed
          }"
          :style="{
            top: isMiniProgram ? 0 : 44 + statusBarHeight + 'px'
          }"
        >
          <scroll-view class="feed-tab-scroll" scroll-x>
            <div
              v-for="(item, index) in classList"
              :key="index"
              :class="['demand-word', { active: index === classIndex }]"
              @click="changeTab(index)"
            >
              {{ item.class1Name }}
            </div>
          </scroll-view>
        </div>

        <template v-if="dataList.length">
          <div
            v-for="(good, skuIndex) in dataList"
            :key="skuIndex"
            class="good-item"
          >
            <component
              :is="getComponentType(good)"
              :key="good.skuBase.skuId"
              :sku-index="skuIndex"
              :sku="good"
              :router-name="'homeGoods'"
              :report-modle="'homeGoods'"
              :map-id="'homeGoodsExpose'"
              :common-tracer-param="{
                class_code: classCode
              }"
              :rank="false"
            ></component>
          </div>
          <page-bottom use-logo></page-bottom>
        </template>
        <template v-else-if="!isLoading">
          <empty
            :desc="
              hasHomeAddress
                ? '您的家乡菜正在筹备中\n敬请期待'
                : '请在左上方位置选择您的家乡，选择后，将为您展示家乡商品'
            "
            :type="1"
            :img="'Empty'"
            class="empty-box"
            style="padding: 0 40px; line-height: 20px"
          ></empty>
        </template>
      </div>
      <div v-else class="home-empty">
        <template v-if="isConfigLoading">
          <van-loading
            type="spinner"
            size="24px"
            color="#17C261"
            class="home-loading"
          >
            加载中...
          </van-loading>
        </template>
        <template v-else>
          <empty
            :desc="
              hasHomeAddress
                ? '您的家乡菜正在筹备中\n敬请期待'
                : '请在左上方位置选择您的家乡，选择后，将为您展示家乡商品'
            "
            :type="1"
            :img="'Empty'"
            class="empty-box"
            style="padding: 40px; line-height: 20px"
          />
        </template>
      </div>
    </div>

    <cart-float-window @beforeGoCart="onClickFloatCartTrack" />

    <van-popup
      v-model="showAreaPicker"
      round
      position="bottom"
      class="area-popup"
      :close-on-click-overlay="true"
    >
      <van-cascader
        :options="cascaderOptions"
        :title="cascaderTitle"
        :active-color="themeColor"
        closeable
        style="padding-top: 10px; padding-bottom: 5px"
        @close="closeAreaPicker"
        @change="onCascaderChange"
        @finish="onCascaderFinish"
      />
      <div class="area-confirm-wrap">
        <div
          class="area-confirm-btn"
          :class="{ disabled: tempSelected.length === 0 }"
          @click.stop="confirmCascader"
        >
          保存并查看家乡菜
        </div>
      </div>
    </van-popup>
    <!-- 首次进入弹窗：选家乡领红包 -->
    <van-popup
      v-model="showSelectHometownPopup"
      round
      position="center"
      :close-on-click-overlay="true"
      class="home-coupon-popup"
      overlay-class="home-coupon-overlay"
    >
      <div class="popup-wrapper">
        <div class="title">
          <span class="t1">{{ popupTitle || '选家乡' }}</span>
          <span v-if="!popupTitle && hasCoupon" class="t2">领大额红包</span>
        </div>
        <div class="sub">您的家乡商品将<span class="hl">优先展示</span></div>
        <div v-if="hasCoupon" class="coupon-card">
          <div class="left">
            <div class="amount">
              <span class="yen">¥</span>
              <span class="num">{{ popupCoupon.faceValue }}</span>
            </div>
            <div class="limit">{{ popupCoupon.thresholdDesc }}</div>
          </div>
          <div class="right">
            <div class="name">{{ popupCoupon.name }}</div>
            <div class="desc" style="white-space: nowrap">
              {{
                popupCoupon.description.length > 9
                  ? popupCoupon.description.slice(0, 9) + '...'
                  : popupCoupon.description
              }}
            </div>
            <div class="expire">{{ popupCoupon.effectiveDesc }}</div>
          </div>
        </div>
        <div v-if="hasCoupon" class="tip">选择家乡后到账</div>
        <div class="confirm-btn" @click="confirmSelectHometown">去选家乡</div>
      </div>
    </van-popup>
    <div
      v-if="showSelectHometownPopup"
      class="home-coupon-close"
      @click="selectHometownClose"
    >
      <img class="x" :src="closeIcon" alt="close" />
    </div>
  </page>
</template>
<script>
import { miniProgramEnv } from '@/defines/environment'
import { areaList as vantAreaList } from '@vant/area-data'
import { getCookie } from '@/utils/cookie'
import ScrollView from '@/common/widget/ScrollView/index.vue'
import PageBottom from '@/common/widget/pageBottom'
import SkuSingle from '@/common/widgets/newGood/skuSingle'
import SkuMultiple from '@/common/widgets/newGood/skuMultiple'
import Empty from '@/common/layout/empty/index'
import CartFloatWindow from '@/common/widgets/cart_float_window'
import headBgImg from '@/images/goods_rank/activity_head.png'
import locationIcon from '@/images/home_goods/locaction.png'
import closeIcon from '@/images/home_goods/icon_close.png'
import { API } from '@/api'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
export default {
  name: 'HomeGoods',
  components: {
    ScrollView,
    Empty,
    SkuSingle,
    SkuMultiple,
    CartFloatWindow,
    PageBottom
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initPage()
    })
  },
  data() {
    return {
      dataList: [],
      isLoading: false,
      isMiniProgram: miniProgramEnv.isMiniProgram,
      headImg: headBgImg,
      pageTitle: '',
      contributeText: '',
      classList: [],
      classIndex: 0,
      opacity: 1,
      background: 'transparent',
      titleColor: 'transparent',
      pageFixed: false,
      activeClass1Id: '',
      themeColor: '#17C261',
      mockMap: {},
      showAreaPicker: false,
      areaList: {},
      cascaderOptions: [],
      tempSelected: [],
      cascaderTitle: '请选择家乡省/市/区',
      areaDisplayText: '选择省/市/区',
      locationIcon,
      closeIcon,
      showSelectHometownPopup: false,
      hasHomeAddress: false,
      isConfigLoading: false,
      initialLoading: true,
      initialLoadingTimerId: null,
      onScrollHandler: null,
      // 分页状态
      pageNo: 1,
      pageSize: 30,
      isLastPage: false,
      isLoadingMore: false,
      // 弹窗券信息（仅取第一个）
      popupCoupon: {
        faceValue: 5,
        thresholdDesc: '满50元可用',
        name: '蔬菜鲜肉优惠红包',
        description: '限蔬菜鲜肉类目商品可用',
        effectiveDesc: '到账3天有效'
      },
      // 原始券列表（提交后端用）
      popupCouponList: [],
      popupTitle: '',
      hasCoupon: false,
      customTips: '',
      showInfoIcon: false
    }
  },
  computed: {
    isEmpty() {
      return this.classList.length === 0
    },
    classCode() {
      if (this.classList.length > 0) {
        const classCode = this.classList?.[this.classIndex]?.class1Id
        return String(classCode)
      }
      return ''
    },
    areaDisplayTextShort() {
      const text = this.areaDisplayText || ''
      if (text.length > 10) {
        return text.slice(0, 8) + '...'
      }
      return text
    }
  },
  // 监控路由状态的改变获取参数重载页面
  watch: {},
  methods: {
    async initPage() {
      // 启动兜底计时器：最长 1.5s 后强制移除白底遮罩，避免长时间空白
      this.initialLoadingTimerId = setTimeout(() => {
        if (this.initialLoading) this.initialLoading = false
      }, 1500)

      // 加载远端地区数据（不阻塞首屏渲染）
      this.fetchRemoteAreaList()
      // 先获取地址，如果没有则弹窗；有则展示并继续加载数据（不阻断主流程）
      try {
        const res = await API.homegoods.getHomeGoodsDetail({ key: 'hometown' })
        const addr = res || ''

        if (addr) {
          this.areaDisplayText = addr
          this.hasHomeAddress = true
        } else {
          this.showSelectHometownPopup = true
          this.tracerExposePopup()
          this.fetchPopupCoupon()
        }
      } catch (e) {
        // 接口异常时，不阻断主流程
      }
      // 加载自定义页面配置（首屏所需），完成后尽快移除白底遮罩
      try {
        await this.fetchCustomPage()
        this.initialLoading = false
      } finally {
        if (this.initialLoadingTimerId) clearTimeout(this.initialLoadingTimerId)
        this.initialLoadingTimerId = null
      }

      // 随后异步加载商品数据，避免阻塞首屏
      this.goodsRank().catch(() => {})
    },
    tracerExposePopup() {
      tracerVuePlugin.request({
        spm: 'n.5228.11024.0',
        type: 8,
        page_id: 5228
      })
    },
    async fetchRemoteAreaList() {
      try {
        const resp = await fetch(
          'https://img-oss.yunshanmeicai.com/mall-entrance/region.json'
        )
        const region = await resp.json()
        const provinceList = {}
        const cityList = {}
        const countyList = {}

        // 反向映射 name -> code，便于通过层级限定筛选
        const provinceEntries = Object.entries(vantAreaList.province_list)
        const cityEntries = Object.entries(vantAreaList.city_list)
        const countyEntries = Object.entries(vantAreaList.county_list)

        const findProvinceCode = pname => {
          const found = provinceEntries.find(([, n]) => n === pname)
          return found ? found[0] : ''
        }
        const findCityCode = (pcode, cname) => {
          const prefix = pcode.slice(0, 2)
          let found = cityEntries.find(
            ([code, n]) => n === cname && code.startsWith(prefix)
          )
          if (!found) found = cityEntries.find(([, n]) => n === cname)
          return found ? found[0] : ''
        }
        const findCountyCode = (ccode, aname) => {
          const prefix = ccode.slice(0, 4)
          let found = countyEntries.find(
            ([code, n]) => n === aname && code.startsWith(prefix)
          )
          if (!found) found = countyEntries.find(([, n]) => n === aname)
          return found ? found[0] : ''
        }

        // 构造符合 Vant 的 area-list
        ;(region || []).forEach(prov => {
          const pName = prov?.name
          const pCode = pName ? findProvinceCode(pName) : ''
          if (!pCode) return
          provinceList[pCode] = pName
          ;(prov.child || []).forEach(city => {
            const cName = city?.name
            const cCode = cName ? findCityCode(pCode, cName) : ''
            if (!cCode) return
            cityList[cCode] = cName
            ;(city.child || []).forEach(area => {
              const aName = area?.name
              const aCode = aName ? findCountyCode(cCode, aName) : ''
              if (!aCode) return
              countyList[aCode] = aName
            })
          })
        })

        // 如果远端数据为空，降级为官方全量表
        const hasAny =
          Object.keys(provinceList).length +
            Object.keys(cityList).length +
            Object.keys(countyList).length >
          0
        this.areaList = hasAny
          ? {
              province_list: provinceList,
              city_list: cityList,
              county_list: countyList
            }
          : vantAreaList

        // 同时生成级联 options 供 van-cascader 使用
        const buildOptions = () => {
          const provinces = Object.entries(this.areaList.province_list).map(
            ([pcode, pname]) => {
              const childrenCities = Object.entries(this.areaList.city_list)
                .filter(([ccode]) => ccode.startsWith(pcode.slice(0, 2)))
                .map(([ccode, cname]) => {
                  const childrenAreas = Object.entries(
                    this.areaList.county_list
                  )
                    .filter(([acode]) => acode.startsWith(ccode.slice(0, 4)))
                    .map(([acode, aname]) => ({ text: aname, value: acode }))
                  return { text: cname, value: ccode, children: childrenAreas }
                })
              return { text: pname, value: pcode, children: childrenCities }
            }
          )
          return provinces
        }
        this.cascaderOptions = buildOptions()
      } catch (e) {
        // 失败降级使用官方全量表
        this.areaList = vantAreaList
        // 兜底构造 options
        const provinces = Object.entries(vantAreaList.province_list).map(
          ([pcode, pname]) => {
            const childrenCities = Object.entries(vantAreaList.city_list)
              .filter(([ccode]) => ccode.startsWith(pcode.slice(0, 2)))
              .map(([ccode, cname]) => {
                const childrenAreas = Object.entries(vantAreaList.county_list)
                  .filter(([acode]) => acode.startsWith(ccode.slice(0, 4)))
                  .map(([acode, aname]) => ({ text: aname, value: acode }))
                return { text: cname, value: ccode, children: childrenAreas }
              })
            return { text: pname, value: pcode, children: childrenCities }
          }
        )
        this.cascaderOptions = provinces
      }
    },
    async fetchCustomPage() {
      try {
        const res = await API.homegoods.getHomeCustomPage({ key: 'hometown' })
        const data = res || {}
        if (data.topImg) {
          this.headImg = data.topImg
        }
        // 贡献文案
        const money = Number(data.contributeMoney)
        const people = Number(data.contributePeople)

        if (
          !Number.isNaN(money) &&
          money > 0 &&
          !Number.isNaN(people) &&
          people > 0
        ) {
          this.contributeText = `您已累计为家乡贡献了<span class="red">¥${money.toFixed(
            2
          )}</span>消费额，相当于帮助了家乡近<span class="red">${people}</span>位农民一年的可支配收入<span
            v-if="showInfoIcon"
            class="info-icon"
            @click.stop="showSupplementInfo"
          >
            !
          </span>
          <div>SOS 农产品直销热线：4001137137</div>`
          this.showInfoIcon = true
        } else if (!Number.isNaN(money) && money > 0) {
          this.contributeText = `您已累计为家乡贡献了<span class="red">¥${money.toFixed(
            2
          )}</span>消费额<span
            v-if="showInfoIcon"
            class="info-icon"
            @click.stop="showSupplementInfo"
          >
            !
          </span>
          <div>SOS 农产品直销热线：4001137137</div>`
          this.showInfoIcon = true
        } else {
          this.contributeText = `您为家乡贡献的消费额正在统计中…<div>SOS 农产品直销热线：4001137137</div>`
          // money 和 people 都为 0 时，不展示补充说明图标
          this.showInfoIcon = false
        }
        // tips：补充说明文案
        if (data.tips) {
          this.customTips = data.tips
        }
        // tabClass：一级分类
        if (Array.isArray(data.tabClass) && data.tabClass.length) {
          this.classList = data.tabClass.map(it => ({
            class1Id: Number(it.class1Id),
            class1Name: it.name,
            moduleKey: it.moduleKey,
            customSource: it.customSource,
            subClass: Array.isArray(it.subClass) ? it.subClass : [],
            selectedClass2Id:
              Array.isArray(it.subClass) && it.subClass.length
                ? it.subClass[0].class2Id
                : -1
          }))
          this.classIndex = 0
        } else {
          // 接口返回空分类时，清空本地分类与商品，驱动 UI 进入空态
          this.classList = []
          this.classIndex = 0
          this.dataList = []
        }
      } catch (e) {
      } finally {
        this.isConfigLoading = false
      }
    },
    async fetchPopupCoupon() {
      try {
        const res = await API.homegoods.popupHomeCouponList({
          key: 'HOMETOWN_SELECT'
        })
        const list = res?.couponList || []
        this.popupTitle = res?.title || ''
        this.popupCouponList = list
        this.hasCoupon = Array.isArray(list) && list.length > 0
        if (list.length > 0) {
          const c = list[0]
          this.popupCoupon = {
            faceValue: c.faceValue || 5,
            thresholdDesc: c.thresholdDesc || '',
            name: c.name || '',
            description: c.description || '',
            effectiveDesc: c.effectiveDesc || ''
          }
        }
      } catch (e) {}
    },
    buildMock() {},
    showSupplementInfo() {
      const html =
        this.customTips ||
        '1.本页面所述的家乡，由您（即买家用户，下同）通过美菜商城自行设置而来，如实际与您的家乡所在地不符，您可以根据自身意愿和需求通过【家乡菜页面左上方位置 】进行调整；<br/>2.您为家乡商品贡献的金额，根据您近一年来在美菜商城下单购买的家乡商品实付金额汇总而来；<br/>3.帮助的农民数量=您为家乡商品贡献的金额/2024年农村居民人均可支配收入23119元;<br/>4.2024年农村居民人均可支配收入23119元，来自统计局官方数据：https://www.stats.gov.cn/sj/zxfb/202501/t20250117_1958325.html'
      if (this.$dialog?.alert && this.showInfoIcon) {
        this.$dialog.alert({
          title: '补充说明',
          message: html,
          allowHtml: true,
          messageAlign: 'left',
          confirmButtonText: '我知道了',
          confirmButtonColor: this.themeColor,
          className: 'home-supplement-dialog'
        })
      }
    },
    getComponentType(good) {
      if (good.ssuList.length === 1) {
        return 'sku-single'
      } else {
        return 'sku-multiple'
      }
    },
    async goodsRank() {
      // 在首屏期间避免频繁重绘导航样式
      this.opacity = 1
      this.background = 'transparent'
      this.titleColor = 'transparent'
      document.title = this.pageTitle
      // 初始化地区展示
      this.areaDisplayText =
        this.areaDisplayText || this.getAreaTextFromCookies()
      this.classIndex = 0
      await this.getDataList(this.classIndex)
      // 首屏数据加载完成后再绑定滚动监听，避免 isLastPage 未就绪导致误触发
      this.$nextTick(() => {
        if (typeof requestIdleCallback === 'function') {
          requestIdleCallback(this.handleScroll)
        } else {
          setTimeout(this.handleScroll, 0)
        }
      })
      // 首次进入弹窗：后端已有地址则不展示
      if (!this.hasHomeAddress) {
        this.showSelectHometownPopup = true
      } else {
        this.showSelectHometownPopup = false
      }
      // 当分类为空时，确保空态区域刷新
      if (!this.classList.length) {
        this.dataList = []
      }
    },

    changeTab(index) {
      if (this.classIndex === index) return
      this.classIndex = index
      this.$track(this.$trackMap.homeGoods.clickTab, {
        class_code: this.classCode
      })
      this.getDataList(index)
    },
    async getDataList(index) {
      try {
        const classItem = this.classList[index] || {}
        this.activeClass1Id = (classItem?.class1Id || '') + ''
        // 首次请求时稍作加大，减少“加载更多”频率
        const isFirstPage = this.pageNo === 1
        const pageSize = isFirstPage
          ? Math.max(this.pageSize, 30)
          : this.pageSize
        let pageNo = 1
        const aggregatedRows = []
        let continueFetch = true

        const fetchOnce = async () => {
          const params = {
            moduleKey: classItem?.moduleKey,
            customSource: classItem?.customSource,
            class1Id: classItem?.class1Id,
            class2Id: classItem?.selectedClass2Id || -1,
            page: pageNo,
            size: pageSize
          }
          const res = await API.homegoods.getHomeGoodsRank(params)
          const block = Array.isArray(res) ? res[0] : res?.data?.[0] || {}
          const rows = Array.isArray(block?.rows) ? block.rows : []
          const isLastPage = Number(block?.isLastPage)
          aggregatedRows.push(...rows)
          // 仅当服务端仍有下一页且当前累计不足阈值时继续拉取
          const needMinCount = 10
          const shouldContinue =
            aggregatedRows.length < needMinCount && isLastPage === 0
          if (shouldContinue) {
            pageNo += 1
            return true
          }
          // 记录分页状态
          this.pageNo = pageNo
          this.isLastPage = isLastPage === 1
          return false
        }

        // 最多连续请求 5 页以防止异常循环
        for (let i = 0; i < 5 && continueFetch; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          continueFetch = await fetchOnce()
        }

        this.dataList = aggregatedRows
      } catch (e) {
        this.dataList = []
      }
      this.isLoading = false
      this.$Loading && this.$Loading.hide && this.$Loading.hide()
    },
    async fetchMore() {
      if (this.isLoading || this.isLoadingMore || this.isLastPage) return
      // 双重保险：进入加载流程立刻标记，避免 iPhone 6 多次触发并发请求
      this.isLoadingMore = true
      this.isLoadingMore = true
      try {
        const classItem = this.classList[this.classIndex] || {}
        const nextPage = this.pageNo + 1
        const params = {
          moduleKey: classItem?.moduleKey,
          customSource: classItem?.customSource,
          class1Id: classItem?.class1Id,
          class2Id: classItem?.selectedClass2Id || -1,
          page: nextPage,
          size: this.pageSize
        }
        const res = await API.homegoods.getHomeGoodsRank(params)
        const block = Array.isArray(res) ? res[0] : res?.data?.[0] || {}
        const rows = Array.isArray(block?.rows) ? block.rows : []
        const isLastPage = Number(block?.isLastPage) === 1
        if (rows.length) this.dataList = this.dataList.concat(rows)
        this.pageNo = nextPage
        this.isLastPage = isLastPage
      } catch (e) {}
      this.isLoadingMore = false
    },
    goBack() {
      this.$back()
    },
    handleScroll() {
      if (this.isEmpty || !this.$refs.expandHeader) return

      const checkAndLoadMore = () => {
        // 顶部导航透明/固定逻辑
        const boundingRect = this.$refs.expandHeader?.getBoundingClientRect?.()
        const boundingTop = boundingRect ? boundingRect.top : 0
        const navBar = document.querySelector('.cms-nav-bar')
        const navBarHeight = navBar?.getBoundingClientRect?.()?.height || 0
        const topHeight = 172 - 12 - navBarHeight
        if (typeof boundingTop === 'number') {
          if (boundingTop < -60) {
            this.opacity = 1
            this.background = '#fff'
            this.titleColor = '#fff'
          } else {
            this.background = 'transparent'
            this.titleColor = 'transparent'
          }
          this.pageFixed = boundingTop < -topHeight
        }

        // 触底加载（多重兜底计算，兼容 iOS 低版本）
        if (this.isLastPage || this.isLoadingMore || this.isLoading) return
        const scrollTop =
          window.pageYOffset !== undefined
            ? window.pageYOffset
            : document.documentElement.scrollTop || document.body.scrollTop || 0
        const winHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight ||
          0
        const body = document.body
        const docEl = document.documentElement
        const docHeight = Math.max(
          body.scrollHeight,
          docEl.scrollHeight,
          body.offsetHeight,
          docEl.offsetHeight,
          body.clientHeight,
          docEl.clientHeight
        )
        const distanceToBottom = docHeight - (scrollTop + winHeight)
        if (distanceToBottom < 200) {
          this.fetchMore()
        }
      }

      // 使用 rAF 做简单节流
      let ticking = false
      this.onScrollHandler = () => {
        if (!ticking) {
          ticking = true
          requestAnimationFrame(() => {
            checkAndLoadMore()
            ticking = false
          })
        }
      }

      try {
        window.addEventListener('scroll', this.onScrollHandler, {
          passive: true
        })
      } catch (e) {
        window.addEventListener('scroll', this.onScrollHandler)
      }
      window.addEventListener('resize', this.onScrollHandler)
      window.addEventListener('touchend', this.onScrollHandler)
      // 首次绑定后立即检测一次，避免首屏就无法触发加载
      checkAndLoadMore()
    },
    rebindScroll() {
      // 重置导航透明状态
      this.opacity = 1
      this.background = 'transparent'
      this.titleColor = 'transparent'
      // 解绑旧监听
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler)
        window.removeEventListener('resize', this.onScrollHandler)
        window.removeEventListener('touchend', this.onScrollHandler)
        this.onScrollHandler = null
      }
      // 重新绑定
      this.$nextTick(() => {
        this.handleScroll()
      })
    },
    setCookie(name, value, days = 30) {
      const expires = new Date(
        Date.now() + days * 24 * 60 * 60 * 1000
      ).toUTCString()
      document.cookie = `${name}=${value}; expires=${expires}; path=/`
    },
    getAreaTextFromCookies() {
      const cCity = getCookie('mc_loguser_city') || ''
      const cArea = getCookie('mc_loguser_area') || ''
      const provinceCode = (cCity || cArea)?.slice(0, 2) + '0000'
      const source =
        this.areaList && this.areaList.province_list
          ? this.areaList
          : vantAreaList
      const provName = source.province_list[provinceCode]
      const cityName = cCity ? source.city_list[cCity] : ''
      const areaName = cArea ? source.county_list[cArea] : ''
      const names = [provName, cityName, areaName].filter(Boolean)
      return names.length ? names.join(' ') : ''
    },
    onCascaderChange({ selectedOptions }) {
      // 当返回市级：保留已选市，清空区
      const opts = selectedOptions || []
      if (opts.length === 2) {
        this.tempSelected = [opts[0], opts[1]]
      } else if (opts.length === 1) {
        // 返回省级：保留省，清空市/区
        this.tempSelected = [opts[0]]
      } else {
        this.tempSelected = opts
      }
      const names = (selectedOptions || []).map(i => i.text)
      const title = names.join('')
      this.cascaderTitle = title || '请选择家乡省/市/区'
    },
    async onCascaderFinish({ selectedOptions }) {
      // 完成某级选择时（通常到区），记录选择
      this.tempSelected = selectedOptions || []
    },
    async confirmCascader() {
      if (this.tempSelected.length === 0) {
        this.$toast && this.$toast('请选择家乡省/市/区')
        return
      }
      this.$track && this.$track(this.$trackMap?.homeGoods?.chooseAreaSave)
      const [p, c, a] = this.tempSelected
      // cookies
      if (c && c.value) this.setCookie('mc_loguser_city', c.value)
      if (a && a.value) this.setCookie('mc_loguser_area', a.value)
      // 展示文本
      const names = [p && p.text, c && c.text, a && a.text].filter(Boolean)
      this.areaDisplayText = names.join(' ')
      this.showAreaPicker = false
      // 等待后端写入成功，再刷新页面数据
      this.hasHomeAddress = true
      this.showSelectHometownPopup = false
      try {
        const param = names.join('_')
        this.$Loading && this.$Loading()
        const resp = await API.homegoods.applyHomeGoodsDetail({
          key: 'hometown',
          type: 1,
          param,
          receiveModelList: this.popupCouponList.map(it => it.modelId) || []
        })
        console.log('resp', resp)
        let msg = ''
        if (typeof resp === 'string') {
          msg = resp
        } else {
          msg = '更新家乡异常，请重试'
        }
        if (msg && this.$toast) this.$toast(msg)
      } catch (e) {
      } finally {
        this.$Loading && this.$Loading.hide && this.$Loading.hide()
      }

      // 刷新全部数据
      await this.fetchCustomPage()
      this.classIndex = 0
      await this.getDataList(this.classIndex)
      // 重新绑定滚动并恢复透明导航
      this.rebindScroll()
    },
    confirmSelectHometown() {
      this.showSelectHometownPopup = false
      this.$track(this.$trackMap.homeGoods.chooseHomeClick)
      try {
        localStorage.setItem('home_goods_show_select_popup', '1')
      } catch (e) {}
      this.showAreaPicker = true
    },
    closeSelectHometownPopup() {
      this.showSelectHometownPopup = false
      try {
        localStorage.setItem('home_goods_show_select_popup', '1')
      } catch (e) {}
    },
    beforeDestroy() {
      if (this.initialLoadingTimerId) clearTimeout(this.initialLoadingTimerId)
      this.initialLoadingTimerId = null
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler)
        window.removeEventListener('resize', this.onScrollHandler)
        window.removeEventListener('touchend', this.onScrollHandler)
        this.onScrollHandler = null
      }
    },
    selectHometownClose() {
      this.$track(this.$trackMap.homeGoods.chooseHomeClose)
      this.goBack()
    },
    closeAreaPicker() {
      this.$track(this.$trackMap.homeGoods.chooseAreaClose)
      this.showAreaPicker = false
    },
    onClickFloatCartTrack() {
      this.$track(this.$trackMap.homeGoods.clickFloatCart)
    }
  }
}
</script>
<style lang="scss" scoped>
.hot-sale-header {
  position: relative;

  height: 360px;

  color: #fff;
  background-size: 100% 100%;

  .header-inner {
    position: absolute;
    left: 0.26rem /* 23/50 */;
    right: 0.26rem /* 23/50 */;
    bottom: 0.44rem;
    cursor: pointer;
  }
  .header-title {
    @include text(24px /* 28/50 */, #eafff3, true);
  }
  .contribute-box {
    margin-top: 8px;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    color: #1a1a1a;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .contribute-text {
    @include text(12px, #1a1a1a);
    // v-html 渲染的内容不会带 scoped 标记，这里使用 deep 选择器
    ::v-deep .red {
      color: #f03100 !important;
      font-weight: 600;
    }
    /* v-html 注入的 info-icon：改为描边圆圈，无背景 */
    ::v-deep .info-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      border-radius: 50%;
      background: transparent;
      border: 1px solid #9e9e9e;
      color: #808080;
      font-size: 12px;
      font-weight: 600;
      margin-left: 6px;
    }
  }
  .contribute-text {
    @include text(12px, #1a1a1a);
    line-height: 20px;
  }
  .info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 50%;
    background: transparent;
    border: 1px solid #9e9e9e;
    color: #808080; /* gray */
    font-size: 12px;
    font-weight: 600;
    margin-left: 6px;
  }
  &.mini {
    height: 300px;
  }
}
.rank-cotent {
  box-sizing: border-box;
  position: relative;
  top: -12px;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  .good-item {
    background-color: #fff;
    padding-bottom: 6px;
  }
  .empty-box {
    position: relative;
    width: 80%;
    top: 2.4rem; /* 120/50 */
    background-color: #fff;
  }
  .home-empty {
    padding: 40px 0 80px;
    background: #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    min-height: 40vh; // 让缺省图区域更靠上，不至于居中过低
  }
}
.expand-tab {
  position: sticky;
  left: 0;
  z-index: 9;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  &.fixed {
    background-color: #fff;
    /* 吸顶时去掉圆角 */
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .feed-tab-scroll {
    writing-mode: initial !important;
    @include flex(row, flex-start, flex-start, nowrap);
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .demand-word {
    position: relative;
    width: max-content;
    height: 22px;
    box-sizing: border-box;
    flex: none;
    flex-shrink: 0;
    margin-right: 18px;
    transition: color 0.2s;
    padding: 0;
    background: transparent;
    @include text(16px, #262626, true);
    @include flex-row-center;
    &.active {
      color: #17c261;
    }
    &.active::after {
      text-align: center;
      content: '';
      position: absolute;

      bottom: -8px;
      height: 3px;
      width: 30px;
      background-color: #17c261;
      border-radius: 2px;
    }
  }
}

.cms-nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}

/* 初始白底加载遮罩样式 */
.page-initial-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
}

.home-coupon-popup {
  .popup-wrapper {
    width: 5.6rem;
    padding: 0.44rem 0.32rem 0.36rem;
    background: #ffffff;
    border-radius: 0.24rem;
    text-align: center;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
  }
  .title {
    margin-top: 0.04rem;
    .t1 {
      @include text(0.44rem, #333, true);
      margin-right: 0.08rem;
    }
    .t2 {
      font-weight: 700;
      font-size: 0.44rem;
      background: linear-gradient(180deg, #ff5e26 0%, #ff2d00 100%);
      background-clip: text; // add standard property for compatibility
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .sub {
    margin-top: 0.16rem;
    margin-bottom: 0.24rem;
    @include text(0.28rem, #666);
    .hl {
      color: #ff3a00;
    }
  }
  .coupon-card {
    display: flex;
    align-items: center;
    margin: 0rem 0.06rem 0.08rem;
    padding: 0.2rem 0;
    background: #ffffff; // 外层无边框、无分割线
    border-radius: 0.2rem;
    border: none;
    box-shadow: none;
    .left {
      width: 1.8rem;
      text-align: center;
      background: linear-gradient(180deg, #fff5f2 0%, #ffe9e3 100%);
      padding: 0.3rem 0.08rem 0.3rem;
      border-right: none; // 设计无分隔线
      border-radius: 0.12rem; // 左侧独立模块圆角
      .amount {
        display: inline-flex;
        align-items: baseline;
        justify-content: center;
        .yen {
          @include text(0.28rem, #ff3a00, true);
          margin-right: 0.02rem;
        }
        .num {
          @include text(0.68rem, #ff3a00, true);
          line-height: 1;
        }
      }
      .limit {
        margin-top: 0.06rem;
        @include text(0.22rem, #ff3a00);
        opacity: 0.8;
      }
    }
    .right {
      flex: 1;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0.2rem 0.16rem 0.2rem 0.26rem; // 与左侧垂直内边距对齐
      border: 1px solid #eef0f2; // 右框边线
      border-radius: 0.12rem; // 与左框圆角对齐
      .name {
        @include text(0.3rem, #333, true);
      }
      .desc {
        margin-top: 0.08rem;
        line-height: 0.4rem;
        @include text(0.24rem, #8c8c8c);
        width: 80%;
        line-height: normal;
      }
      .expire {
        margin-top: 0.08rem;
        @include text(0.24rem, #ff3a00);
      }
    }
  }
  .tip {
    margin-top: -0.08rem;
    margin-bottom: 0.8rem;
    @include text(0.24rem, #bfbfbf);
  }
  .confirm-btn {
    height: 0.92rem;
    line-height: 0.92rem;
    background: linear-gradient(180deg, #ff4b1e 0%, #ef2f00 100%);
    color: #fff;
    border-radius: 0.14rem;
    @include text(0.34rem, #fff, true);
    box-shadow: 0 6px 12px rgba(239, 47, 0, 0.3);
  }
}

.home-coupon-close {
  position: fixed;
  left: 50%;
  bottom: 18%;
  transform: translateX(-50%);
  z-index: 10002;
  .x {
    width: 0.6rem;
    height: 0.6rem;
  }
}

.nav-left {
  display: inline-flex;
  align-items: center;
}
.maple-nav-bar__arrow {
  background: rgba(0, 0, 0, 0.48);
  border-radius: 14px;
  padding: 4px;
  margin-right: 6px;
  font-size: 18px;
}
.nav-area {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  gap: 6px;
  margin-left: 6px;
  .nav-loc-icon {
    width: 0.28rem;
    height: 0.28rem;
  }
  .text {
    max-width: 4.8rem;
    @include text(14px, #ffffff);
    @include text-overflow-ellipsis-single;
  }
}
.nav-area.with-bg {
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.48);
  border-radius: 14px;
  .text {
    color: #fff !important;
  }
}
.mini-area {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  background: transparent;
  position: absolute;
  z-index: 100;
  left: 20px;
  top: 8px;
  .nav-loc-icon {
    width: 0.28rem;
    height: 0.28rem;
    margin-right: 6px;
  }
  .text {
    @include text(14px, #fff);
  }
}
.mini-area {
  background: rgba(0, 0, 0, 0.48);
  border-radius: 12px;
}
</style>

<style lang="scss">
/* 弹窗样式对齐设计稿 */
.area-popup {
  height: 66vh !important; // 直接作用在弹窗根节点
}
.area-popup .van-area {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.area-popup .van-cascader {
  /* 预留底部确认区高度，避免最后一行被遮挡，考虑安全区 */
  height: calc(66vh - 88px - constant(safe-area-inset-bottom));
  height: calc(66vh - 88px - env(safe-area-inset-bottom));
  background: #fff;
  display: flex;
  flex-direction: column;
  /* 取消 van-cascader 自身滚动，仅允许内部选项区域滚动 */
  overflow: hidden;
}
.area-popup .van-tab__pane-wrapper {
  /* 预留底部按钮空间，避免小屏设备（如 iPhone 7）被覆盖 */
  padding-bottom: calc(88px + constant(safe-area-inset-bottom));
  padding-bottom: calc(88px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}
/* 直接为可滚动的选项容器增加底部内边距，彻底避免被遮挡（iPhone 6/7/8 等无安全区设备） */
.area-popup .van-cascader__options {
  padding-bottom: 88px;
  box-sizing: border-box;
}
.area-confirm-wrap {
  background: #fff;
  padding: 12px 16px calc(16px + constant(safe-area-inset-bottom));
  padding: 12px 16px calc(16px + env(safe-area-inset-bottom));
  position: sticky;
  bottom: 0;
  z-index: 1001; // 提高层级，避免 iOS 触摸事件落到下方列上
  pointer-events: auto;
  border-top: 1px solid #f0f0f0;
}
.area-confirm-btn {
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 24px;
  background: #17c261;
  color: #fff;
  font-weight: 600;
}
.area-confirm-btn.disabled {
  background: #e5e5e5;
  color: #bbb;
}
.area-popup .van-picker__columns {
  flex: 1;
  height: auto; // 让列区域自适应撑满剩余高度
}
.home-coupon-overlay {
  background: rgba(0, 0, 0, 0.6) !important;
}
.home-supplement-dialog {
  .van-dialog {
    border-radius: 12px;
  }
  .van-dialog__header {
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
  }
  .van-dialog__content {
    color: #333;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
  }
  .van-dialog__confirm {
    color: #15bb5c !important;
    background: transparent !important;
    border: none !important;
  }
  .van-dialog__footer {
    padding-bottom: 12px;
  }
}

.empty-box {
  position: relative;

  height: 100%;
}
</style>
